/**
 * @generated SignedSource<<d28452a8ee27ad98dc7a036e39602cf1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpHead_viewer$data = {
  readonly isPdpUrlTranslationEnabled?: boolean | null;
  readonly " $fragmentType": "PdpHead_viewer";
};
export type PdpHead_viewer$key = {
  readonly " $data"?: PdpHead_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpHead_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpHead_viewer",
  "selections": [
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isPdpUrlTranslationEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "translatedPdpUrls"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "212bdcefa3a647a7499cd65731f14454";

export default node;
